<!--floorTime 定时设置-->
<template>
  <div class="archiverstype">
    <div class="con">
      <floorTree @checkItem="checkItem2"></floorTree>
      <div class="right-table">
        <div class="search">
          <el-input style="width: 360px;" size="mini" placeholder="输入设备名称、设备ID、回路编号搜索" suffix-icon="el-icon-search"
            v-model="filterText2"> </el-input>
          <div class="btns">
            <!-- multipleSelection -->
            <el-button type="warning" style="padding: 7px 15px !important;" :disabled="multipleSelection.length==0"
              plain size="mini" @click="batchDeletion">批量删除</el-button>
            <el-button type="primary" style="padding: 7px 15px !important;margin: 0;" size="mini"
              @click="add_ed">新增</el-button>
          </div>
        </div>

        <el-table :data="tableData" border stripe :tree-props="{children: 'children', hasChildren: 'hasChildren'}"
          @selection-change="handleSelectionChange">
          <el-table-column type="selection" width="39" align="center">
          </el-table-column>
          <el-table-column type="expand">
            <template slot-scope="props">
              <div class="ul">
                <div class="li">
                  <span class="n">循环时间：</span>
                  <div class="zhou">
                    <div class="zhouLi" @click="e.b=!e.b" :class="{'active':e.b}" v-for="(e,u) in zhou" :key="i">{{e.a}}
                    </div>
                  </div>
                </div>
                <div class="li" style="margin-top: 10px;">
                  <span class="n">开启时间：</span>
                  <el-time-select class="seled" placeholder="开启时间" size="mini" v-model="startTime" :picker-options="{
                    start: '08:30',
                    step: '00:15',
                    end: '18:30'
                  }">
                  </el-time-select>
                  <span class="n">关闭时间：</span>
                  <el-time-select class="seled" placeholder="关闭时间" size="mini" v-model="endTime" :picker-options="{
                    start: '08:30',
                    step: '00:15',
                    end: '18:30',
                    minTime: startTime
                  }">
                  </el-time-select>
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="设备名称" prop="name">
            <template slot-scope="scope">
              <span class="texted">{{scope.row.name}}</span>
            </template>
          </el-table-column>
          <el-table-column label="回路编号" width="120">
            <template slot-scope="scope">
              <span class="texted">{{scope.row.a}}</span>
            </template>
          </el-table-column>
          <el-table-column label="创建时间" width="150">
            <template slot-scope="scope">
              <span class="texted">{{scope.row.b}}</span>
            </template>
          </el-table-column>
          <el-table-column label="标签" width="120" align="center">
            <template slot-scope="scope">
              <span class="texted">{{scope.row.c}}</span>
            </template>
          </el-table-column>
          <el-table-column label="启用状态" width="100" align="center">
            <template slot-scope="scope">
              <span class="qiyong" v-if="scope.row.d"> <span></span>启用</span>
              <span class="jin" v-else><span></span>禁用</span>
            </template>
          </el-table-column>
          <el-table-column label="操作" prop="desc" width="100" align="center">
            <template slot-scope="scope">
              <el-link type="danger" @click="del_fn(scope.$index)">删除</el-link>
            </template>
          </el-table-column>
        </el-table>

        <span style="    position: absolute;
        right: 15px;
        bottom: 6px;width:calc(100% - 35px);">
          <div class="divider-line" style="margin-top: 20px;"></div>
          <div class="paging">
            <el-pagination background :page-sizes="[10, 20, 30, 40, 50]" :page-size="15"
              layout="total, sizes, prev, pager, next, jumper" :total="800">
            </el-pagination>
          </div>
        </span>
      </div>

    </div>
  </div>
</template>

<script type="text/javascript">
  import elIconBtn from '@/components/module/iconBtns.vue'
  import floorTree from '@/components/module/tree/floorTree.vue'
  export default {
    //inject: ['reload'],
    components: {
      elIconBtn,
      floorTree
    },
    data () {
      return {
        multipleSelection: [],
        startTime: '',
        endTime: '',
        zhou: [{
          a: '周一',
          b: true,
        },{
          a: '周二',
          b: false,
        },{
          a: '周三',
          b: true,
        },{
          a: '周四',
          b: true,
        },{
          a: '周五',
          b: true,
        },{
          a: '周六',
          b: false,
        },{
          a: '周日',
          b: false,
        },],
        value1: true,
        heights: Math.round((document.getElementById('app').clientHeight)*0.55),
        defaultProps: {
          children: 'children',
          label: 'typeName'
        },
        filterText: "",
        filterText2: "",
        getEntityTypeList: this.$store.unitStore.state.getEntityTypeList,
        tableData: [{
          name: 'A栋1层办公室照明灯',
          a: 'BH16859456',
          b: '2024-06-07 09:00',
          c: '普通照明',
          d: 1,
          children: [{
            num: 7,
            color: '#368ED9',
          },]
        },{
          name: 'A栋1层办公室照明灯',
          a: 'BH16859456',
          b: '2024-06-07 09:00',
          c: '普通照明',
          d: 0,
          children: [{
            num: 7,
            color: '#368ED9',
          },]
        },{
          name: 'A栋1层办公室照明灯',
          a: 'BH16859456',
          b: '2024-06-07 09:00',
          c: '普通照明',
          d: 1,
          children: [{
            num: 7,
            color: '#368ED9',
          },]
        },{
          name: 'A栋1层办公室照明灯',
          a: 'BH16859456',
          b: '2024-06-07 09:00',
          c: '普通照明',
          d: 0,
          children: [{
            num: 7,
            color: '#368ED9',
          },]
        },{
          name: 'A栋1层办公室照明灯',
          a: 'BH16859456',
          b: '2024-06-07 09:00',
          c: '普通照明',
          d: 1,
          children: [{
            num: 7,
            color: '#368ED9',
          },]
        },{
          name: 'A栋1层办公室照明灯',
          a: 'BH16859456',
          b: '2024-06-07 09:00',
          c: '普通照明',
          d: 0,
          children: [{
            num: 7,
            color: '#368ED9',
          },]
        },{
          name: 'A栋1层办公室照明灯',
          a: 'BH16859456',
          b: '2024-06-07 09:00',
          c: '普通照明',
          d: 1,
          children: [{
            num: 7,
            color: '#368ED9',
          },]
        },{
          name: 'A栋1层办公室照明灯',
          a: 'BH16859456',
          b: '2024-06-07 09:00',
          c: '普通照明',
          d: 0,
          children: [{
            num: 7,
            color: '#368ED9',
          },]
        },{
          name: 'A栋1层办公室照明灯',
          a: 'BH16859456',
          b: '2024-06-07 09:00',
          c: '普通照明',
          d: 1,
          children: [{
            num: 7,
            color: '#368ED9',
          },]
        },{
          name: 'A栋1层办公室照明灯',
          a: 'BH16859456',
          b: '2024-06-07 09:00',
          c: '普通照明',
          d: 0,
          children: [{
            num: 7,
            color: '#368ED9',
          },]
        }],
        typeEnum: 0,

      }
    },

    mounted () {

    },
    methods: {

      // 添加弹窗
      add_ed () {
        this.tableData.push(this.tableData[0]);
        this.$message({showClose: true,message: '添加成功',type: 'success'});
        return
        this.dialogStatus='add';
        this.dialogVisible=true;
        this.$nextTick(() => {
          this.$refs["temp"].clearValidate();
        });
        this.temp={};
      },
      batchDeletion () {
        this.$confirm('此操作将删除所选数据, 是否继续?','提示',{
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.$message({showClose: true,message: '删除成功',type: 'success'});
        })
      },
      handleSelectionChange (v) {
        this.multipleSelection=v;
      },
      //删除
      del_fn (id) {
        console.log(id);
        this.$confirm('是否删除此设备','提示',{
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.tableData.splice(id,1);
          this.$message({showClose: true,message: '删除成功',type: 'success'});
          return
          let d={
            "id": id
          }
          deleteEnergyBuildingInfoById(d).then(res => {
            if(res.code==200) {
              this.$message({showClose: true,message: '删除成功',type: 'success'});
              this.getList();
              var bool=this.$store.unitStore.state.buildingNum
              this.$store.unitStore.commit('setBuildingNum',!bool);
            } else {
              this.$message.error('删除失败');
            }
          })
        }).catch(() => {
          // ...
        });
      },
      goUrl (v) {

      },
      checkItem2 (data) {
        console.log(data);
      },
      //筛选
      filterNode (value,data) {
        if(!value) return true;
        return data.typeName.indexOf(value)!==-1;
      },


    }
  }
</script>

<style scoped lang="scss">
  .paging {
    display: flex;
    justify-content: flex-end;
    margin-top: 10px;

  }

  .seled {
    width: 120px;
    margin-right: 12px;
  }

  .ul {
    display: flex;
    flex-direction: column;

    .li {
      display: flex;
      align-items: center;

      .zhou {
        display: flex;

        .zhouLi {
          border-radius: 12px;
          color: #666;
          font-family: Microsoft YaHei;
          font-weight: regular;
          font-size: 12px;
          background: #E6E6E6;
          width: 48px;
          height: 24px;
          text-align: center;
          line-height: 24px;
          margin-right: 4px;
          cursor: pointer;
        }

        .active {
          background: #368ED9;
          color: #fff;
        }
      }

      .n {
        color: #666;
        font-family: Microsoft YaHei;
        font-weight: regular;
        font-size: 13px;

      }
    }
  }

  .qiyong {
    color: #1D97FF;
    font-family: Microsoft YaHei;
    font-weight: regular;
    font-size: 13px;
    border-radius: 12px;
    background: #D1EAFF;
    padding: 2px 12px;
    padding-left: 9px;

    >span {
      display: inline-block;
      background: #1D97FF;
      width: 6px;
      height: 6px;
      border-radius: 50%;
      margin-right: 4px;
      margin-bottom: 1px;

    }
  }

  .jin {
    color: #666;
    font-family: Microsoft YaHei;
    font-weight: regular;
    font-size: 13px;
    border-radius: 12px;
    background: #F0F0F0;
    padding: 2px 12px;
    padding-left: 9px;

    >span {
      display: inline-block;
      background: #666;
      width: 6px;
      height: 6px;
      border-radius: 50%;
      margin-right: 4px;
      margin-bottom: 1px;

    }
  }

  .texted {
    color: #1A1A1A;
    font-family: Microsoft YaHei;
    font-weight: regular;
    font-size: 14px;

  }

  .search {
    display: flex;
    justify-content: space-between;
    margin-bottom: 20px;
  }

  .titles {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-top: 20px;
    margin-bottom: 8px;
    color: #666;
    font-family: Microsoft YaHei;
    font-weight: regular;
    font-size: 12px;

    .l1 {
      border-radius: 4px;
      background: #368ED9;
      width: 24px;
      height: 24px;
      margin-right: 20px;
      text-align: center;
      line-height: 24px;
      color: #fff;
      font-size: 14px;
    }

    .l2 {
      border-radius: 4px;
      background: #E6E6E6;
      width: 24px;
      height: 24px;
      margin-right: 20px;
    }

    .l3 {
      border-radius: 4px;
      background: #FF7A2F;
      width: 24px;
      height: 24px;
      margin-right: 20px;
    }

    .rightd {
      border-radius: 4px;
      background: #FFF;
      border: 1px solid #E6E6E6;
      padding: 2px;
      display: flex;
      align-items: center;
      cursor: pointer;
    }

    .leftd {
      display: flex;
      align-items: center;

      img {
        margin-right: 20px;
      }
    }
  }

  .name-wrapper {
    position: absolute;
    width: 50px;
  }

  .spot img {
    position: absolute;
    width: .5rem;
    height: .5rem;
    left: 0;
    top: 0;
  }

  .center {
    position: relative;
    display: flex;
    flex-wrap: wrap;
  }

  .num_box {
    display: flex;
    border-radius: 4px;
    border: 1px solid #EBEBEB;
    justify-content: space-around;
    margin-top: 20px;
    height: 66px;
    align-items: center;

    .num {
      color: #1A1A1A;
      font-family: Microsoft YaHei;
      font-weight: bold;
      font-size: 18px;
      margin-bottom: 2px;
      text-align: center;
    }

    .e {
      color: #666;
      font-family: Microsoft YaHei;
      font-weight: regular;
      font-size: 12px;

    }
  }

  .custom-tree-node {
    display: flex;
    width: calc(100% - 51px);

    .tt {
      padding: 0px 5px;
      color: #1A1A1A;
      font-family: Microsoft YaHei;
      font-weight: regular;
      font-size: 14px;

    }

    .aaa {
      flex: 1;
      display: flex;
      justify-content: flex-end;
      font-family: Microsoft YaHei;
      font-weight: regular;
      font-size: 12px;
      align-items: center;
    }
  }

  .archiverstype {
    .con {
      width: 100%;
      min-height: 100%;
      box-sizing: border-box;
      display: flex;
      padding: 8px;

      .left-tree {
        width: 224px;
        min-height: 100%;
        background-color: #fff;
        margin-right: 8px;
        box-sizing: border-box;
        padding: 12px;
        padding-top: 20px;

        .btns {
          margin-top: 20px;
          color: #1A1A1A;
          font-family: Microsoft YaHei;
          font-weight: regular;
          font-size: 14px;
          display: flex;
          justify-content: space-between;

          .txt {
            font-family: Microsoft YaHei;
            font-weight: regular;
            font-size: 12px;
            padding-right: 8px;
          }

          .i {
            color: #0D75D4;
            font-family: Microsoft YaHei;
            font-weight: regular;
            font-size: 12px;
          }
        }

        /deep/.el-button {
          padding: 6px 11px !important;
        }
      }

      .public-flex {
        display: flex;
        align-items: center;
        justify-content: center;
      }

      .right-table {
        width: calc(100% - 232px);
        min-height: 100%;
        background-color: #fff;
        box-sizing: border-box;
        padding: 20px;
        position: relative;
        padding-bottom: 80px;

      }
    }
  }
</style>
<style>
  .el-scrollbar__wrap {
    overflow: auto;
  }

  .el-popover {
    padding: 0 !important;
    border-radius: 4px;
    overflow: hidden;
  }
</style>